import AddIcon from '@mui/icons-material/Add';
import { FormattedMessage } from 'react-intl';
import RowMenuItem from '../../DataGrid/RowMenuItem';
import messages from './messages';

const EditMembership = ({ onClick }: { onClick: () => void }) => (
  <RowMenuItem
    dataTestId="access-settings-edit-membership"
    icon={<AddIcon />}
    label={<FormattedMessage {...messages.AccessSettingsDataGridTableRowActionsEditMembership} />}
    onClick={onClick}
  />
);

export default EditMembership;
